import { useState } from "react";
import { Download, Share, Plus } from "lucide-react";
import { usePwa } from "@/context/PwaContext";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

// Renders an install action ONLY where it is mounted (worker + admin areas).
export function InstallButton({ variant = "compact", dark = false }) {
  const pwa = usePwa();
  const [showIos, setShowIos] = useState(false);
  if (!pwa || pwa.installed) return null;
  if (!pwa.canInstall && !pwa.isIOS) return null;

  const onClick = () => { if (pwa.isIOS) setShowIos(true); else pwa.promptInstall(); };

  return (
    <>
      {variant === "full" ? (
        <Button onClick={onClick} data-testid="pwa-install-button" className="w-full justify-start gap-2 rounded-xl bg-brand-cyan/15 font-semibold text-brand-cyan hover:bg-brand-cyan/25">
          <Download className="h-4 w-4" /> Install TiplyMe app
        </Button>
      ) : (
        <Button onClick={onClick} data-testid="pwa-install-button" variant="ghost" size="icon" className={`rounded-full ${dark ? "text-brand-cyan" : "text-primary"}`} aria-label="Install app">
          <Download className="h-4 w-4" />
        </Button>
      )}

      <Dialog open={showIos} onOpenChange={setShowIos}>
        <DialogContent data-testid="pwa-ios-dialog">
          <DialogHeader><DialogTitle className="font-heading">Add TiplyMe to your Home Screen</DialogTitle></DialogHeader>
          <ol className="space-y-3 text-sm text-muted-foreground">
            <li className="flex items-center gap-2"><Share className="h-4 w-4 text-primary" /> Tap the <span className="font-semibold text-foreground">Share</span> button in Safari.</li>
            <li className="flex items-center gap-2"><Plus className="h-4 w-4 text-primary" /> Choose <span className="font-semibold text-foreground">Add to Home Screen</span>.</li>
            <li className="flex items-center gap-2"><Download className="h-4 w-4 text-primary" /> Tap <span className="font-semibold text-foreground">Add</span> — TiplyMe now opens like an app.</li>
          </ol>
        </DialogContent>
      </Dialog>
    </>
  );
}
